import { Result } from "antd"
import "./FormDocuSign.css"


const FormDocuSignConnectSuccess = () => {
    return (
        <>
            <nav className="verify-welcome-nav">
                <div className="verify-logo">Advisors Reserve</div>
            </nav>
            <div className="docusign-connect-result-container">
                <Result
                    status="success"
                    title="DocuSign Connected!"
                    subTitle="You may now close this window."
                    extra={[]}
                />
            </div>
        </>
    )
}

export default FormDocuSignConnectSuccess